module.exports = __webpack_public_path__ + "static/media/personNew.619b2b4f.svg";